function wrapShopifyPaymentButton(){
  var is_hulk_payment_set = false
  const hulk_shopify_button = setInterval(function () {
      if($('.shopify-payment-button').length > 0){
          if(($('.shopify-payment-button').html().includes("ShopifyPay-button") || $('.shopify-payment-button').html().includes("Checkout-button") || $('.shopify-payment-button').html().includes("payment-button")) ){
              if($(".hulk_buy_now_handle").length <= 0){
                  if($('.shopify-payment-button').html().includes("ShopifyPay-button")){
                      $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>" );
                  }else if ($('.shopify-payment-button').html().includes("payment-button")) {
                      $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='payment-button'></div>");
                  }else{
                      $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>" );
                  }
                  $('.shopify-payment-button').css({'pointer-events':'none'});
              }else {
                  $(".hulk_buy_now_handle").addClass("hulk-buy_now");
                  $('.shopify-payment-button').css({'pointer-events':'none'});
              }
              is_hulk_payment_set = true
          }else{
              is_hulk_payment_set = true
          }
      }else{
          is_hulk_payment_set = true
      }
      if (is_hulk_payment_set) {
          console.log('Wrapped 3rd Party Buttons');
          clearInterval(hulk_shopify_button);
      }
      
  }, 1000);

  if($('.shopify-payment-button').length > 0 && ($('.shopify-payment-button').html().includes("ShopifyPay-button") || $('.shopify-payment-button').html().includes("Checkout-button") || $('.shopify-payment-button').html().includes("payment-button") ) ){
      if($(".hulk_buy_now_handle").length <= 0){
          if($('.shopify-payment-button').html().includes("ShopifyPay-button")){
              $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='ShopifyPay-button'></div>" );
          }else if ($('.shopify-payment-button').html().includes("payment-button")) {
              $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='payment-button'></div>");
          }else{
              $('.shopify-payment-button').wrap("<a class='hulk-buy_now hulk_buy_now_handle' data-testid='Checkout-button'></div>" );
          }
          $('.shopify-payment-button').css({'pointer-events':'none'});
      }else {
          $(".hulk_buy_now_handle").addClass("hulk-buy_now");
          $('.shopify-payment-button').css({'pointer-events':'none'});
      }
  }
}

window.addEventListener('load',()=>{
  if (window.hulkapps) wrapShopifyPaymentButton();
})